import { memo } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import Main from './components/Main';
import { CoefficientsFeedProvider, CoefficientsOptionsProvider } from './store';
import type { CoefficientsOptions } from './store/types';

const Calendar = ({ options }: { options: CoefficientsOptions }) => (
  <CoefficientsOptionsProvider options={options}>
    <CoefficientsFeedProvider>
      <BrowserRouter basename={options.routingBasePath}>
        <Routes>
          <Route path='/:mode?' element={<Main />} />
          <Route path='/:type/:mode?' element={<Main />} />
          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
      </BrowserRouter>
    </CoefficientsFeedProvider>
  </CoefficientsOptionsProvider>
);

export default memo(Calendar);
